<template>
    <b-modal
        :visible="visible"
        :title="$t('text.addGroups')"
        @ok="toggleOkButton"
        @cancel="toggleCancelButton"
        :cancel-disabled="groups.loading || saveInProgress"
        :ok-disabled="groups.loading || saveInProgress"
        :ok-only="true"
        :ok-title="$t('label.close')"
        lazy
    >
        <div if="!saveInProgress">
            <Multiselect
                :options="computedGroups"
                :loading="groups.loading"
                track-by="id"
                label="display_name"
                v-model="selectedGroups"
                :multiple="true"
                :searchable="true"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="false"
                :hide-selected="true"
                :preserve-search="true"
                :placeholder="$t('text.typeToSearch')"
                @search-change="searchGroups"
            >
                <!-- SingleLabel -->
                <template slot="singleLabel" slot-scope="props">
                    <span class="option__desc">
                        <span class="option__title">{{
                            props.option.display_name
                        }}</span>
                    </span>
                </template>

                <!-- Option -->
                <template slot="option" slot-scope="props">
                    <div class="option__desc">
                        <div class="option__title">
                            {{ props.option.display_name }}
                        </div>
                        <div class="option__small">
                            {{ props.option.description }}
                        </div>
                    </div>
                </template>

                <!-- No Results -->
                <template slot="noResult">{{
                    $t('text.noSearchResult')
                }}</template>
            </Multiselect>

            <!-- Add selected groups button -->
            <b-button
                variant="primary"
                style="margin-top: 10px; width: 100%"
                @click="addGroups()"
                >{{ $t('text.addSelectedGroups') }}</b-button
            >
        </div>
        <div>
            <b-list-group flush>
                <b-list-group-item
                    v-for="(m, index) in memberships"
                    :key="index"
                >
                    <div class="pull-left">
                        <a-button type="ghost" style="display: hidden"
                            >&nbsp;</a-button
                        >
                        {{ m.group.display_name }}
                    </div>
                    <div class="pull-right">
                        <b-button variant="ghost" disabled v-if="m.saving">
                            <a-icon type="loading" />
                        </b-button>
                        <b-button variant="ghost-success" disabled v-if="m.id">
                            <a-icon type="check" disabled />
                        </b-button>
                        <b-button
                            variant="ghost-danger"
                            disabled
                            v-if="!m.id && !m.saving"
                            :title="$t('text.memberShipAlreadyExists')"
                        >
                            <a-icon type="warning" />
                        </b-button>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        memberId: {
            required: true,
        },
        memberType: {
            default: 'user',
        },
        visible: {
            type: Boolean,
            default: false,
        },
        companyId: {},
    },

    data() {
        return {
            groups: this.$resource('groups/search'),
            addingGroups: false,
            memberships: [],
            selectedGroups: [],
        }
    },

    created() {
        // console.log(this.groups)
        this.groups.fetch()
    },

    methods: {
        addGroups() {
            this.addingGroups = true

            // Create an array of groupmember-resources
            this.memberships = this.selectedGroups.map(
                this.createGroupMembership
            )

            this.memberships.forEach(gm => {
                gm.save().then(res => {
                    let group_id = res.getData().group_id

                    let indexOf = this.selectedGroups.filter(
                        g => g.id == group_id
                    )[0]

                    this.selectedGroups.splice(indexOf, 1)
                })
            })
        },

        createGroupMembership(group) {
            let membership = {
                group_id: group.id,
                member_id: this.memberId,
                member_type: this.memberType,
                group: JSON.parse(JSON.stringify(group)),
            }
            return this.$resource('groupmembers', membership)
        },

        searchGroups(query) {
            let params = {
                query: query,
                filter: {
                    company_id: this.companyId,
                },
            }

            this.groups.fetch({
                params: params,
            })
        },

        toggleOkButton() {
            this.memberships = []
            // console.log('toggleOk', this)
            this.$emit('okToggle', true)
        },

        toggleCancelButton() {
            this.selectedGroups = []
            this.memberships = []
        },
    },

    computed: {
        saveInProgress() {
            return this.memberships.filter(m => m.saving).length > 0
        },
        computedGroups() {
            return this.groups.models
        },
    },
}
</script>
